import { useQuery } from '@apollo/client';
import { useAuth } from '@clerk/clerk-react';
import {
  GET_ALL_PORTFOLIOS,
  GET_PORTFOLIO_BY_USER_ID,
} from '~/graphql/queries/portfolio';
import { isPortfolioOwner } from '~/utils/rbac';

interface Portfolio {
  id: string;
  name: string;
  companyId?: string | null;
  createdAt?: string;
  fund_code?: string;
  fund_type?: string;
  inception_date?: string;
  base_currency?: string;
  user_id?: string | null;
}

/**
 * Hook to fetch portfolios
 * Automatically uses GET_PORTFOLIO_BY_USER_ID for portfolio_owner role
 * Otherwise uses GET_ALL_PORTFOLIOS
 * @param skip - Optional flag to skip the query
 */
export const usePortfolios = (skip = false) => {
  const auth = useAuth();
  const isOwner = isPortfolioOwner();

  const queryVariables = isOwner ? { userId: auth.userId || '' } : undefined;

  const { data, loading, error } = useQuery(
    isOwner ? GET_PORTFOLIO_BY_USER_ID : GET_ALL_PORTFOLIOS,
    {
      variables: queryVariables,
      skip: skip || (isOwner && !auth.userId) || !auth.isLoaded,
      fetchPolicy: 'network-only', // Always fetch from network, bypass cache
    },
  );

  // Return portfolios array (both queries return arrays)
  const portfolios: Portfolio[] = data?.EQPortfolio || [];

  return {
    portfolios,
    loading,
    error,
  };
};
